declare namespace $ {

	export class $mol_icon_launch extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=launch.view.tree.d.ts.map